import * as React from 'react';
import { cn } from '@/lib/utils';

export interface ScrollableTabsContainerProps {
  children: React.ReactNode;
  height?: string;
  className?: string;
}

/**
 * ScrollableTabsContainer
 * 
 * A reusable wrapper component that creates a fixed-height scrollable container
 * for tab content. This keeps headers, KPIs, and tab navigation visible while
 * allowing only the tab content to scroll.
 * 
 * @example
 * ```tsx
 * <ScrollableTabsContainer height="calc(100vh - 400px)">
 *   <TabsContent value="overview">...</TabsContent>
 *   <TabsContent value="financials">...</TabsContent>
 * </ScrollableTabsContainer>
 * ```
 */
export function ScrollableTabsContainer({
  children,
  height = 'calc(100vh - 400px)',
  className,
}: ScrollableTabsContainerProps) {
  return (
    <div
      className={cn(
        'overflow-y-auto overflow-x-hidden',
        'scrollbar-thin scrollbar-thumb-neutral-300 scrollbar-track-transparent',
        'dark:scrollbar-thumb-neutral-700',
        className
      )}
      style={{ height }}
    >
      {children}
    </div>
  );
}
